import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import Swal from "sweetalert2"; // Assuming Swal is already installed
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyD0R0Uu6qhX11d7nWMYVLoypBma-Ax2TcU",
  authDomain: "parqd-9884f.firebaseapp.com",
  projectId: "parqd-9884f",
  storageBucket: "parqd-9884f.appspot.com",
  messagingSenderId: "143574223756",
  appId: "1:143574223756:web:ed099132fe5749d7e124a9",
  measurementId: "G-HX0CYK3HHJ",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const messaging = getMessaging(app);
const storage = getStorage(app);
// Check Notification Permission
// if ("Notification" in window) {
//   if (Notification.permission === "granted") {
//     console.log("Notifications are allowed.");
//   } else if (Notification.permission === "denied") {
//     Swal.fire({
//       title: "Allow Notifications",
//       text: "Please allow notifications in your browser settings to receive updates.",
//       icon: "warning",
//       confirmButtonText: "OK",
//     });
//   } else {
//     Notification.requestPermission().then((permission) => {
//       if (permission === "granted") {
//         console.log("User granted notifications.");
//       } else {
//         Swal.fire({
//           title: "Allow Notifications",
//           text: "Please enable notifications in your browser to receive messages.",
//           icon: "warning",
//           confirmButtonText: "OK",
//         });
//       }
//     });
//   }
// }

// // Check Location Permission
// if ("geolocation" in navigator) {
//   navigator.geolocation.getCurrentPosition(
//     (position) => {
//       console.log("Location access granted:", position.coords);
//     },
//     (error) => {
//       if (error.code === error.PERMISSION_DENIED) {
//         Swal.fire({
//           title: "Allow Location Access",
//           text: "Please enable location services in your browser settings for better service.",
//           icon: "warning",
//           confirmButtonText: "OK",
//         });
//       }
//     }
//   );
// } else {
//   Swal.fire({
//     title: "Location Not Supported",
//     text: "Your browser does not support location services.",
//     icon: "error",
//     confirmButtonText: "OK",
//   });
// }

// Register Service Worker and Get Token
// if ("serviceWorker" in navigator) {
//   navigator.serviceWorker
//     .register("/firebase-messaging-sw.js", {
//       scope: "/web/",
//     })
//     .then((registration) => {
//       console.log("Service Worker registered:", registration);

//       getToken(messaging, {
//         vapidKey:
//           "BA0S90eRdBY9GcVofymnSozqwSAbrhXRor8TZhLW6iT-o51OLzmlBhLYoHRUQJrhcCoF6j_Sw1cseKDsE4WPJuU",
//       })
//         .then((currentToken) => {
//           if (currentToken) {
//             console.log("Current token:", currentToken);
//             localStorage.setItem("device_token", currentToken);
//           } else {
//             console.log(
//               "No registration token available. Request permission to generate one."
//             );
//           }
//         })
//         .catch((err) => {
//           console.error("Error getting token:", err);
//         });

//       // Handle incoming messages
//       onMessage(messaging, (payload) => {
//         console.log("Message received:", payload);
//         Swal.fire({
//           title: "New Message!",
//           text: payload.notification.body,
//           icon: "info",
//           confirmButtonText: "OK",
//         });
//       });
//     })
//     .catch((error) => {
//       console.error("Service Worker registration failed:", error);
//     });
// }

if ("serviceWorker" in navigator) {
  navigator.serviceWorker
    .register("/firebase-messaging-sw.js")
    .then((registration) => {
      console.log("Service Worker registered:", registration);

      getToken(messaging, {vapidKey:"BA0S90eRdBY9GcVofymnSozqwSAbrhXRor8TZhLW6iT-o51OLzmlBhLYoHRUQJrhcCoF6j_Sw1cseKDsE4WPJuU",}).then((currentToken) => {
          if (currentToken) {
            console.log("Current token:", currentToken);
            localStorage.setItem("device_token", currentToken);
          } else {
            console.log(
              "No registration token available. Request permission to generate one."
            );
          }
        })
        .catch((err) => {
          console.error("Error getting token:", err);
          localStorage.setItem("device_token", "currentToken");
        });

      onMessage(messaging, (payload) => {
        // console.log("Message received:", payload);
        Swal.fire({
          title: "New Message!",
          text: payload.notification.body,
          icon: "info",
          confirmButtonText: "OK",
        });
      });
    })
    .catch((error) => {
      console.error("Service Worker registration failed:", error);

    });
}

export { app,getToken, onMessage, db, storage };
